import React, { useEffect, useState } from "react";
import Table from "../Table/Table";
import Table_Buttons from "../Table_Button/Table_button";
import { API } from "../../Redux/actions/API";
import Navbar from "../Navbar/Navbar";
import { toast } from "react-toastify";

function MessageHistory() {
  const [referralApi, setreferralApi] = useState([]);
  const [leftreferralApi, setleftreferralApi] = useState([]);
  // const [search, setSearch] = useState(user)
  const [currentPage, setcurrentPage] = useState(1);
  //   const [select, setSelect] = useState("2")
  const [listPerpage, setlistPerpage] = useState(10);
  const [currentPage2, setcurrentPage2] = useState(1);
  const [listPerpage2, setlistPerpage2] = useState(10);
  // const [fromdate, setFromdate] = useState('')
  // const [allMember, setAllMember] = useState('')

  const referral_API = async () => {
    try {
      let responceRight = await API?.post("/getNewsMessageAdminHistory ");
      console.log("My_Team", responceRight.data.data);
      responceRight = responceRight.data.data;
      setleftreferralApi([]);
      let arrayLeft = [];

      responceRight.forEach((item, index) => {
        arrayLeft.push({
          sr: index + 1,
          id: `${item?.id} `,
          imgrank: item?.imgrank,
          message: item?.message,
          edate: `${item?.edate} `,
          staking: (
            <>
              <button
                style={{ color: "black" }}
                onClick={(e) => {
                  Status_active(item.id);
                }}
              >
                Delete
              </button>
            </>
          ),
        });

        setleftreferralApi(arrayLeft);
      });
    } catch (e) {
      console.log("Error While calling Myteam API", e);
    }
  };

  const Status_active = async (value) => {
    console.log(value);

    let num = +value;
    console.log("num", num);
    try {
      let responceRight = await API?.post("/deleteMessageByAdmin ", {
        id: num,
      });
      console.log("My_Team", responceRight);
      toast.success(responceRight.data.data.result);
      window.location.reload();
    } catch (e) {
      console.log("Error While calling Myteam API", e);
    }
  };

  useEffect(() => {
    referral_API();
  }, []);

  const indexOfLastPost = currentPage * listPerpage;
  const indexOfFirstPage = indexOfLastPost - listPerpage;
  const indexOfLastPost2 = currentPage2 * listPerpage2;
  const indexOfFirstPage2 = indexOfLastPost2 - listPerpage2;
  const currentPost = referralApi.slice(indexOfFirstPage, indexOfLastPost);
  const currentPostleft = leftreferralApi.slice(
    indexOfFirstPage2,
    indexOfLastPost2
  );

  var [my_team, set_my_team] = new useState({
    cols: [
      { Header: "S.No.", accessor: "sr" },
      // { Header: 'ID', accessor: 'id' },
      { Header: "Rank", accessor: "imgrank" },
      { Header: "Message", accessor: "message" },
      { Header: "Date", accessor: "edate" },
      {
        Header: "Action",
        accessor: "staking",
      },
    ],
  });

  return (
    <div>
      <Navbar />
      <div class="content-page">
        <div class="content">
          <div class="container">
            {/* <!-- Inline Form --> */}
            <div class="row">
              <div class="col-md-12">
                <div class="panel panel-primary">
                  <div class="panel-heading">
                    <h4 class="panel-title">Message History</h4>
                  </div>
                  <div class="panel-body">
                    <form
                      ng-submit="SearchUserid();"
                      class="ng-pristine ng-valid ng-valid-maxlength"
                    >
                      <div class="form-inline" role="form"></div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="panel panel-default">
                  <div class="panel-body" style={{ overflow: "scroll" }}>
                    <Table data={currentPostleft} columns={my_team.cols} />

                    <Table_Buttons
                      indexOfFirstPage={indexOfFirstPage2}
                      indexOfLastPost={indexOfLastPost2}
                      setcurrentPage={setcurrentPage2}
                      currentPage={currentPage2}
                      totalData={leftreferralApi.length}
                      listPerpage={listPerpage2}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MessageHistory;
